import dayjs from 'dayjs';
import 'dayjs/locale/nb';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React from 'react';

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDateTime(date?: string): string {
	dayjs.locale('nb');
	const parsedDate: dayjs.Dayjs = dayjs(date);
	return parsedDate.tz('Europe/Oslo').format('D. MMM YYYY, HH:mm');
}

export const Time = ({
	date,
	dateTime = date?.toISOString(),
}: {
	date: Date;
	dateTime?: string;
} | {
	date?: Date;
	dateTime: string;
}): React.JSX.Element => {
	return (
		<time dateTime={dateTime}>
			{dateTime ? formatDateTime(dateTime): dateTime}
		</time>
	);
};

